import { render, staticRenderFns } from "./SubGrupoProdutoList.vue?vue&type=template&id=41eed695&scoped=true"
import script from "./SubGrupoProdutoList.vue?vue&type=script&lang=js"
export * from "./SubGrupoProdutoList.vue?vue&type=script&lang=js"
import style0 from "./SubGrupoProdutoList.vue?vue&type=style&index=0&id=41eed695&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41eed695",
  null
  
)

export default component.exports